module.exports = __webpack_public_path__ + "static/media/landmark-alt.00c7ae61.svg";